import { User } from "lucide-react";

function initialsOf(name?: string | null) {
  return (name || "").trim().split(/\s+/).filter(Boolean).map((w) => w[0]).slice(0, 2).join("").toUpperCase();
}

export function Avatar({ name, src }: { name?: string | null; src?: string | null }) {
  const initials = initialsOf(name);
  return (
    <span className="avatar" aria-hidden="true">
      {src ? <img src={src} alt="" /> : initials ? initials : <User size={16} />}
    </span>
  );
}
